export default __webpack_public_path__ + "static/leonie-watson-2e7917635554ff2c236704f004a91df3.jpg";